import { createSelector } from '@reduxjs/toolkit'
import type { RootState } from '@/redux'

// ─── selectIsPostPanelPhase ────────────────────────────────────────────────────
//
// §3d.1.B (TDD amendment 2026-04-24). Single load-bearing definition.
//
// Returns true when the creation shell must unmount in favour of DashboardCanvas:
//   (a) creationStatus === 'fetching_data'  — user confirmed panel proposals; backend is fetching
//   (b) creationStatus === 'complete'       — normal viewing-mode state
//   (c) dashboardPanels.panels.length > 0  — deep-link / refresh case: panels already in Redux
//
// What is NOT post-panel:
//   - flowState === 'awaiting_panels'       — proposal checkboxes still showing; canvas not yet born
//   - the present_panels tool call arriving — AI-side signal only; panels not yet generated
//
// Memoised with createSelector: re-runs only when creationStatus or panelsCount changes.

const selectCreationStatus = (state: RootState) => state.chatSession.creationStatus
const selectPanelsCount = (state: RootState) => state.dashboardPanels.panels.length

export const selectIsPostPanelPhase = createSelector(
  [selectCreationStatus, selectPanelsCount],
  (status, panelsCount): boolean =>
    status === 'fetching_data' ||
    status === 'complete' ||
    panelsCount > 0
)
